<div
  class="card-container"
  [ngClass]="{ unAvaliable: card.count === 0 }"
  *ngFor="let card of cards"
  (click)="takeCard(card)"
>
  <div class="card-quantity">
    <div class="card-quantity-value" *ngIf="card.count > 1000">
      <app-full-value-popup [value]="card.count"></app-full-value-popup>
    </div>
    {{ card.count | thousandSuff }}
  </div>
  <app-test-card
    class="card"
    [rarity]="craftCard.rarity"
    [grade]="craftCard.grade"
    [isPromoCards]="craftCard.isPromoCards"
    [promoCardImage]="craftCard.promoCardImage"
    [element]="craftCard.element"
    [effect]="craftCard.effect"
    [name]="card.apiCard.displayName"
    [fontSize]="card.apiCard.type === 'EXPERIENCE' ? 0.8 : 1.2"
  ></app-test-card>
  <div class="holder" [ngClass]="{ small: card.apiCard.type === 'EXPERIENCE' }">
    <div class="exp-value" *ngIf="card.restoreValue > 1000">
      <app-full-value-popup [value]="card.restoreValue"></app-full-value-popup>
    </div>
    +
    {{ card.restoreValue | thousandSuff }}
    {{ card.apiCard.type === "EXPERIENCE" ? "xp." : "" }}
    <img
      *ngIf="card.apiCard.type === 'ENERGETIC'"
      class="energy-icon"
      src="assets/main-game/modals/EventCardExchanger/TestReward2.png"
      alt=""
    />
  </div>
</div>
